import Head from "next/head";
import { Content, GoogleJobsSchema } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { getGlobal } from "@/functions/getGlobal";
import { jobs_helper } from "@/helpers/jobs_helper";
import * as additionalComponents from "./__components";
import { createTitle } from "@/functions/createTitle";
import { assets_helper } from "@/helpers/asset_helper";

export default function JobPage({ job, content }) {
  const global = getGlobal();
  const job_types = jobs_helper.getCategoryValues("b1cb7cb1-baa1-426d-828b-f253629a61fa", job);
  const site_google_logo_link = assets_helper.find("Google Jobs Logo", "name");

  const [employment_type] = job_types.map(
    (i) =>
      ({
        "d75c7b22-cd65-4739-926c-183a92a240f7": "FULL_TIME", // Permanent
        "2b442aca-fdd8-43c8-95f5-7cd8a1d6d09a": "FULL_TIME",
        "13a42a61-1803-4f99-83a8-6917eacca80a": "PART_TIME",
        "c79f6639-e8dd-4840-a6d5-54d88f37ba3e": "CONTRACTOR",
        "6c197e9c-efa3-496d-8e72-2ea17f14514e": "TEMPORARY",
      })[i.id],
  );

  return (
    <>
      <Head>
        <meta property="og:title" content={job.title} />
        <meta property="og:url" content={`/jobs/${job.url_slug}`} />
        <meta name="twitter:title" content={job.title} />
        <meta
          name="image"
          property="og:image"
          content={job.image ?? "https://cdn.sourceflow.co.uk/__gallery/9ec4a470-2ceb-4b64-b0a5-774ed3bebf24"}
        />
        <meta
          name="twitter:image"
          content={job.image ?? "https://cdn.sourceflow.co.uk/__gallery/9ec4a470-2ceb-4b64-b0a5-774ed3bebf24"}
        />
      </Head>
      <GoogleJobsSchema
        job={job}
        employment_type={employment_type}
        site_name={global["_theme.company.name"]}
        site_domain_link={global["_theme.company.domain"]}
        site_google_logo_link={site_google_logo_link?.file}
      />
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const job = jobs_helper.find(url_slug);
  const sectorsIds = jobs_helper.getCategoryValueIds("a1b79b78-73e5-4285-ad3b-142fb677c082", job);
  const related = jobs_helper.fetch({
    limit: 100,
    exclude: [job.id],
    filter: (i) => sectorsIds.some((s) => JSON.stringify(i.categories).includes(s)),
  });

  return {
    props: {
      meta: {
        title: createTitle(job.title),
      },
      job,
      content: [
        // {
        //   component: "BreadcrumbNavigation",
        //   props: {
        //     items: [
        //       {
        //         label: "Find a Job",
        //         href: getRoute("jobs"),
        //       },
        //       {
        //         label: job.title,
        //         href: getRoute("job", { url_slug }),
        //       },
        //     ],
        //   },
        // },
        {
          component: "Header",
          props: {
            className: "bg-primary text-white",
            title: job.title,
            back: {
              path: "page.job.component.Header.back",
              placeholder: "Back to job search",
              href: getRoute("jobs"),
            },
          },
        },
        {
          component: "JobPageContent",
          props: {
            ...job,
            related,
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  return { paths: jobs_helper.toPaths(), fallback: false };
}
